;(function ($) {

  $(document).ready(function () {
    initMainMenuA11y();
    $('body').on('blur', '.is-submenu-item', blurDropdownSubmenuItem);
    $('body').on('click', '[data-dropdown-submenu-toggle]', dropdownSubmenuToggle);
    $('body').on('mouseenter', '.is-dropdown-submenu-parent', dropdownSubmenuToggleMouseEnter);
    $('body').on('mouseleave', '.is-dropdown-submenu-parent', dropdownSubmenuToggleMouseLeave);
    $('body').on('keyup', '.is-submenu-item a', closeDropdowns);
  });

  /**
   * Setup the Main dropdown menu, remove aria-popup, add aria-controls, the ids for the submenus add aria-expanded.
   */
  function initMainMenuA11y() {
    // console.log('initMainMenuA11y');
    let mainMenu = $('#main_dropdown_menu'),
      lisWithSubmenus = mainMenu.find('.is-dropdown-submenu-parent');

    lisWithSubmenus.each(function (index) {
      let $this = $(this),
        button = $this.find('button'),
        submenu = $this.find('.menu');
      // $this.attr('tabindex', '0');
      button.attr('aria-expanded', 'false');
      button.attr('aria-controls', index + '_submenu');
      submenu.attr('id', index + '_submenu');
    });

  }

  /**
   * Toggle the dropdown menu when the button is clicked and change the aria states
   * @param e
   */
  function dropdownSubmenuToggle(e) {
    // console.log('dropdownSubmenuToggle');
    let $this = $(this),
      parentLi = $this.parent('li');
    if (($this.attr('aria-expanded') === 'false') && (!parentLi.hasClass('is-dropdown-active'))) {
      $this.attr('aria-expanded', 'true');
      parentLi.addClass('is-dropdown-active');
    } else {
      $this.attr('aria-expanded', 'false');
      parentLi.removeClass('is-dropdown-active');
    }
  }

  /**
   * When you hover over the dropdown (<a> or <button>) open the dropdown and change the aria states
   * @param e
   */
  function dropdownSubmenuToggleMouseEnter(e) {
    // console.log('dropdownSubmenuToggleMouseEnter');
    let $this = $(this),
      button = $this.children('button[data-dropdown-submenu-toggle]');
    button.attr('aria-expanded', 'true');
    $this.addClass('is-dropdown-active');
  }

  /**
   * When you leave the hover area close the dropdown and change the aria states
   * @param e
   */
  function dropdownSubmenuToggleMouseLeave(e) {
    // console.log('dropdownSubmenuToggleMouseLeave');
    let $this = $(this),
      button = $this.children('button[data-dropdown-submenu-toggle]');
    button.attr('aria-expanded', 'false');
    $this.removeClass('is-dropdown-active');

  }

  /**
   * Closes the dropdown menu focusing out of of it and handles the aria-expanded logic.
   * @param e
   */
  function blurDropdownSubmenuItem(e) {
    let $this = $(this);
    if (e.relatedTarget !== null) {
      let parentLiClass = e.relatedTarget.parentElement.classList.contains('is-submenu-item');
      if (parentLiClass) {
        return;
      } else {
        let parentLi = $this.parents('.is-dropdown-submenu-parent'),
          parentButton = parentLi.find('button');
        parentLi.removeClass('is-dropdown-active');
        parentButton.attr('aria-expanded', 'false');
      }
    }
  }

  /**
   * Close the Dropdown when hitting the ESC key
   * @param e
   */
  function closeDropdowns(e) {
    // console.log('closeDropdowns', e);
    if (e.keyCode === 27) {
      let parentLi = $(this).parents('.is-dropdown-submenu-parent'),
        parentButton = parentLi.children('button');
      parentButton.attr('aria-expanded', 'false');
      parentLi.removeClass('.is-dropdown-active');
      parentButton.focus();
    }
  }

})(jQuery);
